import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Immutable from 'immutable';
import { bindAll } from '@bibliocommons/utils-react';
import Checkbox from '@bibliocommons/deprecated-base-checkbox';
import { Dropdown } from '@bibliocommons/deprecated-base-dropdown';
import { SHELF_NAMES } from 'app/constants/ShelfConstants';
import '../styles/CancelHoldShelfPrompt.scss';

const propTypes = {
  toAdd: PropTypes.bool,
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func
};

class CancelHoldShelfPrompt extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  getShelfOptions() {
    return Immutable.Map(SHELF_NAMES)
      .valueSeq()
      .toArray()
      .map(name => ({
        label: this.props.intl.formatMessage({ id: `label_shelf_${name}` }),
        value: name
      }));
  }

  handleChangeAddTo(toAdd) {
    this.props.handleChange({ toAdd });
  }

  handleChangeShelf(name) {
    this.props.handleChange({ name });
  }

  render() {
    return (
      <div className="cp-cancel-hold-shelf-prompt">
        <Checkbox
          inline
          className="add-to-shelf-checkbox"
          id="add-to-shelf-checkbox"
          checked={this.props.toAdd}
          handleChange={this.handleChangeAddTo}
          label={<FormattedMessage id="label_also_move_shelf" />}
        />
        <Dropdown
          dataKey="cancel-hold-shelf-prompt-dropdown"
          className="btn-flat btn btn-default"
          options={this.getShelfOptions()}
          selected={<FormattedMessage id={`label_my_shelf_${this.props.name}`} />}
          handleSelect={this.handleChangeShelf}
        />
      </div>
    );
  }
}

CancelHoldShelfPrompt.propTypes = propTypes;

export default injectIntl(CancelHoldShelfPrompt);
